import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { IrisIconComponent } from '@sondermind/iris/icon';

import { IrisIconButtonComponent } from './icon-button.component';

@NgModule({
  declarations: [
    IrisIconButtonComponent
  ],
  imports: [
    CommonModule,
    IrisIconComponent,
  ],
  exports: [
    IrisIconButtonComponent
  ]
})
export class IrisIconButtonModule { }
